module.exports = function (apiEndpoint, $searchRendering) {
    $searchRendering.on('click', '.search-rendering__more-results', function (e) {
        e.preventDefault();
        window.page = window.page + 1;
        ICF.Modules.SearchRendering.InsertResults(apiEndpoint);
    });
};